export const saveDataToLocalStorage = (key:string, data:any) => {
    localStorage.setItem(
        key,
        JSON.stringify(data)
    );
}

export const getDataFromLocalStorage = (key:string) => {
    const data = localStorage.getItem(key);
    if(!data) return null;
    return JSON.parse(data);
}

export const removeDataFromLocalStorage = (key:string) => {
    localStorage.removeItem(key);
}